import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StatusConfigurationState {
  isReload: boolean;
}

const initialState: StatusConfigurationState = {
  isReload: false,
};

const statusConfigurationSlice = createSlice({
  name: "statusConfiguration",
  initialState,
  reducers: {
    setIsReloadStatusConfiguration: (state, action: PayloadAction<boolean>) => {
      state.isReload = action?.payload;
    },
  },
});

export const { setIsReloadStatusConfiguration } =
  statusConfigurationSlice.actions;

export default statusConfigurationSlice.reducer;
